import React from "react";

const DisabledPaymentMethodsAddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      aria-hidden="true"
    >
      <mask
        id="a"
        x="-1"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
      >
        <path fill="#fff" d="M97.88 0H-1v96h98.88V0Z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#FEFEFE"
          fillRule="evenodd"
          d="M91.947 19.2v36.48H48.44v15.6c0 .881-.697 1.603-1.584 1.673l-.141.006H20.402c-1.888-2.755-3.416-5.315-4.649-7.68H40.53v-3.84H14.82v1.972c-6.089-12.75-3.332-19.251-3.332-19.251h13.22V19.2h67.24Z"
          clipRule="evenodd"
        />
        <path
          fill="#878E9B"
          d="M48.24 10.56c8.325 0 16.249 2.587 22.793 7.298l.442.323h20.472c.525 0 .958.397 1.013.908l.006.111v36.48c0 .525-.397.958-.908 1.013l-.11.006h-6.48l-.01.039c-4.176 16.497-19.471 28.315-37.217 28.315-21.16 0-38.328-16.668-38.328-37.246 0-11.497 5.358-21.772 13.776-28.603V19.2c0-.525.398-.958.909-1.013l.11-.006h.298c6.447-4.782 14.501-7.621 23.235-7.621Zm34.688 46.139H48.47V71.28c0 1.44-1.138 2.608-2.565 2.693l-.166.005h-21.13c6.31 5.364 14.578 8.617 23.632 8.617 16.42 0 30.585-10.788 34.687-25.897Zm-60.52 15.243h23.331a.683.683 0 0 0 .687-.572l.006-.089V56.64H13.537c1.577 5.84 4.68 11.083 8.87 15.302Zm68.52-51.723-64.542-.001c-.222.165-.442.333-.66.504l.001 22.42H45.74c1.448 0 2.64 1.116 2.726 2.533l.005.165v8.821h42.458V20.217ZM66.324 44.784l.217.134.32.208.834.562 1.937 1.34c.583.396 1.101.73 1.59 1.023 1.5.896 2.662 1.348 3.404 1.298.678-.044 1.166-.132 1.655-.293l.247-.088 2.087-.915.92-.39.337-.138.307-.12c1.758-.675 3.308.021 4.548 1.49.513.608.867 1.21 1.061 1.633a.84.84 0 0 1-1.475.795l-.146-.28-.107-.19a6.45 6.45 0 0 0-.616-.875c-.83-.982-1.703-1.374-2.664-1.005l-.437.174-.766.322-2.46 1.071-.044.018c-.72.265-1.405.406-2.337.467-1.184.079-2.6-.471-4.375-1.533a31.938 31.938 0 0 1-1.315-.834l-2.312-1.594-.823-.554-.362-.233a2.115 2.115 0 0 0-.055-.033c-1.924-1.094-4.566 1.331-6.416 5.012a.84.84 0 0 1-1.5-.754c.083-.166.168-.33.255-.493l.263-.48c.446-.788.925-1.518 1.429-2.168l.305-.38c1.954-2.344 4.255-3.47 6.494-2.197Zm-53.847.326-.03.41a34.227 34.227 0 0 0-.011 4.4l33.996-.001v-4.08c0-.33-.257-.61-.598-.655l-.095-.006H12.843c-.129 0-.252-.024-.366-.068Zm.212-1.957.043-.007.111-.006H23.69V22.442c-5.868 5.346-9.88 12.586-11 20.712ZM84.135 24v1.629c1.346.237 2.494.713 3.488 1.42l-1.884 2.36c-1.243-.793-2.603-1.189-3.806-1.189-.913 0-1.36.327-1.36.775v.034c0 .551.467.792 2.37 1.171 3.106.602 5.049 1.498 5.049 3.753v.034c0 2.027-1.49 3.375-3.858 3.79v1.583h-3.587v-1.605c-1.665-.266-3.197-.879-4.42-1.839l2.096-2.22c1.36.945 2.835 1.446 4.408 1.446 1.03 0 1.573-.312 1.573-.828v-.034c0-.516-.446-.775-2.31-1.17-2.894-.585-5.128-1.31-5.128-3.771v-.034c0-1.875 1.408-3.311 3.781-3.73V24h3.588ZM57.339 36.12a.84.84 0 0 1 .105 1.673l-.105.007H28.664a.84.84 0 0 1-.105-1.673l.105-.007h28.675Zm-11.865-5.76a.84.84 0 0 1 .105 1.673l-.105.007h-16.81a.84.84 0 0 1-.105-1.673l.105-.007h16.81ZM56.35 24.6a.84.84 0 0 1 .106 1.673l-.106.007H43.496a.84.84 0 0 1-.105-1.673l.105-.007H56.35Zm-16.81 0a.84.84 0 0 1 .106 1.673l-.105.007H28.664a.84.84 0 0 1-.105-1.673l.105-.007H39.54Zm8.7-11.583c-6.9 0-13.345 1.89-18.814 5.164h37.63c-5.592-3.349-12.06-5.164-18.815-5.164Z"
        />
      </g>
      <path
        fill="#878E9B"
        d="M73.768 86.536c7.052 0 12.768-5.716 12.768-12.768C86.536 66.716 80.82 61 73.768 61 66.716 61 61 66.716 61 73.768c0 7.052 5.716 12.768 12.768 12.768Z"
      />
      <path
        fill="#FEFEFE"
        d="M79.648 74.608h-5.04v5.04h-1.68v-5.04h-5.04v-1.68h5.04v-5.04h1.68v5.04h5.04v1.68Z"
      />
      <mask
        id="b"
        width="13"
        height="13"
        x="67"
        y="67"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
      >
        <path
          fill="#fff"
          d="M79.648 74.608h-5.04v5.04h-1.68v-5.04h-5.04v-1.68h5.04v-5.04h1.68v5.04h5.04v1.68Z"
        />
      </mask>
      <g mask="url(#b)">
        <path fill="#FEFEFE" d="M83.848 63.688h-20.16v20.16h20.16v-20.16Z" />
      </g>
    </svg>
  );
};

export default DisabledPaymentMethodsAddIcon;
